import { render } from "./InsertarObservacionTramite.vue?vue&type=template&id=17fb7fac&scoped=true"
import script from "./InsertarObservacionTramite.vue?vue&type=script&lang=js"
export * from "./InsertarObservacionTramite.vue?vue&type=script&lang=js"

import "./InsertarObservacionTramite.vue?vue&type=style&index=0&id=17fb7fac&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17fb7fac"]])

export default __exports__